"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuditedSuperBlocks = exports.getFirstNotAuditedSuperBlock = exports.createFlatSuperBlockMap = exports.createSuperBlockMap = exports.superBlockOrder = exports.SuperBlockStages = exports.SuperBlocks = void 0;
// all superblocks
var SuperBlocks;
(function (SuperBlocks) {
    SuperBlocks["RespWebDesignNew"] = "2022/responsive-web-design";
    SuperBlocks["RespWebDesign"] = "responsive-web-design";
    SuperBlocks["JsAlgoDataStruct"] = "javascript-algorithms-and-data-structures";
    SuperBlocks["JsAlgoDataStructNew"] = "javascript-algorithms-and-data-structures-v8";
    SuperBlocks["FrontEndDevLibs"] = "front-end-development-libraries";
    SuperBlocks["DataVis"] = "data-visualization";
    SuperBlocks["BackEndDevApis"] = "back-end-development-and-apis";
    SuperBlocks["QualityAssurance"] = "quality-assurance";
    SuperBlocks["InfoSec"] = "information-security";
    SuperBlocks["CodingInterviewPrep"] = "coding-interview-prep";
    SuperBlocks["ProjectEuler"] = "project-euler";
    SuperBlocks["RosettaCode"] = "rosetta-code";
})(SuperBlocks || (exports.SuperBlocks = SuperBlocks = {}));
/*
 * SuperBlockStages.New = SHOW_NEW_CURRICULUM === 'true'
 * 'New' -> shown only on english staging at the moment
 *
 * SuperBlockStages.Upcoming = SHOW_UPCOMING_CHANGES === 'true'
 * 'Upcoming' is for development -> not shown on stag or prod anywhere
 */
var SuperBlockStages;
(function (SuperBlockStages) {
    SuperBlockStages[SuperBlockStages["FrontEnd"] = 0] = "FrontEnd";
    SuperBlockStages[SuperBlockStages["Backend"] = 1] = "Backend";
    SuperBlockStages[SuperBlockStages["Extra"] = 2] = "Extra";
    SuperBlockStages[SuperBlockStages["Legacy"] = 3] = "Legacy";
    SuperBlockStages[SuperBlockStages["New"] = 4] = "New";
    SuperBlockStages[SuperBlockStages["Upcoming"] = 5] = "Upcoming";
})(SuperBlockStages || (exports.SuperBlockStages = SuperBlockStages = {}));
// order of buttons on map, this should include all superblocks
// new and upcoming superblocks are removed below
exports.superBlockOrder = {
    [SuperBlockStages.FrontEnd]: [
        SuperBlocks.RespWebDesignNew,
        SuperBlocks.JsAlgoDataStructNew,
        SuperBlocks.FrontEndDevLibs,
        SuperBlocks.DataVis
    ],
    [SuperBlockStages.Backend]: [
        SuperBlocks.BackEndDevApis,
        SuperBlocks.QualityAssurance,
        SuperBlocks.InfoSec
    ],
    [SuperBlockStages.Extra]: [
        SuperBlocks.CodingInterviewPrep,
        SuperBlocks.ProjectEuler,
        SuperBlocks.RosettaCode
    ],
    [SuperBlockStages.Legacy]: [
        SuperBlocks.RespWebDesign,
        SuperBlocks.JsAlgoDataStruct,
    ],
    [SuperBlockStages.New]: [],
    [SuperBlockStages.Upcoming]: []
};
Object.freeze(exports.superBlockOrder);
// removes new and upcoming from superBlockOrder
// not used yet, will be used when adding progress indicators to map
function createSuperBlockMap({ showNewCurriculum, showUpcomingChanges }) {
    const superBlockMap = { ...exports.superBlockOrder };
    if (!showNewCurriculum) {
        superBlockMap[SuperBlockStages.New] = [];
    }
    if (!showUpcomingChanges) {
        superBlockMap[SuperBlockStages.Upcoming] = [];
    }
    return superBlockMap;
}
exports.createSuperBlockMap = createSuperBlockMap;
function createFlatSuperBlockMap({ showNewCurriculum, showUpcomingChanges }) {
    const superBlockMap = { ...exports.superBlockOrder };
    if (!showNewCurriculum) {
        superBlockMap[SuperBlockStages.New] = [];
    }
    if (!showUpcomingChanges) {
        superBlockMap[SuperBlockStages.Upcoming] = [];
    }
    return Object.values(superBlockMap).flat();
}
exports.createFlatSuperBlockMap = createFlatSuperBlockMap;
// this is so we know where to display the "help us translate" section
function getFirstNotAuditedSuperBlock({ language, showNewCurriculum, showUpcomingChanges }) {
    const flatSuperBlockMap = createFlatSuperBlockMap({
        showNewCurriculum,
        showUpcomingChanges
    });
    return null;
}
exports.getFirstNotAuditedSuperBlock = getFirstNotAuditedSuperBlock;
function getAuditedSuperBlocks({ language = 'english', showNewCurriculum, showUpcomingChanges }) {
    const flatSuperBlockMap = createFlatSuperBlockMap({
        showNewCurriculum,
        showUpcomingChanges
    });
    const auditedSuperBlocks = flatSuperBlockMap;
    return auditedSuperBlocks;
}
exports.getAuditedSuperBlocks = getAuditedSuperBlocks;
